import React, { useMemo } from "react";
import {
  DetailsEntities,
  DetailsDealQueryableEntities,
  DetailsProjectQueryableEntities,
  DetailsContractQueryableEntities,
  DetailsContactQueryableEntities,
  DetailsTicketQueryableEntities,
  DetailsTaskQueryableEntities,
  DetailsSubscriptionQueryableEntities,
  DetailsCallsQueryableEntities,
} from "../../../Components/DetailsView/DetailsChildren/DetailsChildren";

export const ClientDetailsChildren = ({ id }) => {
  const formProps = useMemo(() => {
    return { clientId: id };
  }, [id]);
  return (
    <DetailsEntities formProps={formProps}>
      <DetailsDealQueryableEntities filter={`(Deal/ClientId eq ${id})`} />
      <DetailsSubscriptionQueryableEntities
        filter={`(Subscription/ClientId eq ${id})`}
      />
      <DetailsContractQueryableEntities
        filter={`(DirectIndirectClient/Id eq ${id})`}
      />

      <DetailsProjectQueryableEntities
        filter={`(DirectIndirectClient/Id eq ${id})`}
      />

      <DetailsTicketQueryableEntities
        filter={`(DirectIndirectClient/Id eq ${id})`}
      />
      <DetailsTaskQueryableEntities
        filter={`(DirectIndirectClient/Id eq ${id})`}
      />
      <DetailsContactQueryableEntities filter={`(Client/Id eq ${id})`} />
      {/* <DetailsCallsQueryableEntities
        filter={`(DirectIndirectClient/Id eq ${id})`}
      /> */}
    </DetailsEntities>
  );
};
